import type { ComponentProps } from 'react'

import { Icon } from '@/components/icon'
import { Button } from '@/components/ui'

type TBotaoMidiaProps = {
  titulo: string
  icon: ComponentProps<typeof Icon>['name']
  disabled?: boolean
} & ComponentProps<typeof Button>

export const BotaoMidia = ({ titulo, icon, disabled, onClick }: TBotaoMidiaProps) => {
  return (
    <Button
      disabled={disabled}
      variant="ghost"
      onClick={onClick}
      className="shadow-cz font-poppins h-17.5 flex-1 place-items-center gap-4 text-xl text-sky-900 disabled:cursor-not-allowed disabled:text-neutral-500 disabled:opacity-100"
    >
      <Icon name={icon} size={24} />
      <span className="flex items-center gap-2.5">{titulo}</span>
    </Button>
  )
}
